// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { featureFlagClient } from '@trello/feature-flag-client';

import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';
const t = teacupWithHelpers('board_header');

// eslint-disable-next-line @trello/no-module-logic
export const BoardHeaderTemplate = t.renderable(function ({
  name,
  canRename,
  isLoggedIn,
  isUntitled,
  canJoin,
  canInviteMembers,
  canAssign,
  showCopyButton,
  isEmbeddedInAtlassian,
  isTemplate,
  starTooltipKey,
  hasEditPrivileges,
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
any) {
  const classes = {
    'board-header-btn': true,
    'mod-board-name': true,
    'inline-rename-board': true,
    'js-rename-board': canRename,
    'no-edit': !canRename,
    'should-rename': isUntitled && canRename,
  };

  const renderMembersFacepileAndBoardShareButton = function () {
    t.span('.board-header-btn-divider');
    t.span('', function () {
      t.span('.board-header-facepile-wrapper', function () {
        t.div('.board-header-facepile.js-fill-facepile', {
          class: t.classify({ 'js-list-draggable-board-members': canAssign }),
        });

        t.a(
          '#member-count.board-header-btn.board-header-btn-member-count.js-open-show-all-board-members.js-fill-board-member-count',
          { href: '#' },
          function () {},
        );
      });

      if (canInviteMembers) {
        t.span('.board-share-button');
      }

      if (canJoin && !isTemplate) {
        return t.a(
          '.board-header-btn.board-header-btn-without-icon.board-header-btn-join-board.js-join-board',
          { href: '#', title: t.l('workspace-members-can-join-this-board') },
          () =>
            // hovertext to replace helper
            t.span('.board-header-btn-text', () => t.format('join-board')),
        );
      }
    });
  };

  const renderBoardPluginButtons = () => {
    if (!isEmbeddedInAtlassian) {
      // The list of Power-up Buttons
      t.span(
        '.js-pup-header-btns.board-header-btn-react-container.pup-header-btns',
      );

      // The Calendar Power-up button
      t.span('.js-calendar-board-btn.board-header-btn-react-container');

      // The defunct/delisted Map Power-up Button
      t.a('.board-header-btn.hide.js-map-btn', { href: '#' }, function () {
        t.span('.icon-sm.icon-location.board-header-btn-icon');
        return t.span('.board-header-btn-text', () => t.format('map'));
      });

      // The list of Butler-driven custom automation buttons
      t.span('.js-plugin-header-btns');
    }

    if (isLoggedIn && showCopyButton && !isTemplate) {
      t.a('.board-header-btn.js-copy-board', { href: '#' }, function () {
        t.icon('board', { class: 'board-header-btn-icon' });
        return t.span('.board-header-btn-text', () => t.format('copy-board'));
      });
    }

    if (hasEditPrivileges && !isEmbeddedInAtlassian) {
      // The Power-up Settings popover button
      t.span('.js-pup-dropdown-list-btn.board-header-btn-react-container');

      // The Butler Automation button— but confusingly, none of the other Butler buttons
      t.span('.js-butler-header-btns.board-header-btn-react-container');
    }
  };

  t.div({ href: '#', class: t.classify(classes) }, function () {
    t.h1(
      '.js-board-editing-target.board-header-btn-text',
      { dir: 'auto' },
      () => t.text(name),
    );

    return t.input('.board-name-input.js-board-name-input', {
      'aria-label': name,
      spellcheck: 'false',
      dir: 'auto',
      maxLength: 512,
      value: name,
    });
  });

  if (isTemplate) {
    t.div('.board-header-btn-template-badge.js-board-template-badge');
  }

  if (isLoggedIn && !isEmbeddedInAtlassian) {
    t.a(
      '.board-header-btn.js-star-board.board-header-star-container',
      {
        href: '#',
        title: t.l(starTooltipKey),
        'aria-label': t.l('star-or-unstar-board'),
      },
      () => t.icon('star', { class: 'board-header-btn-icon' }),
    );
  }
  t.span('.board-header-btn-divider');

  t.a('.board-header-btn.perms-btn.js-change-vis', {
    href: '#',
    id: 'permission-level',
  });

  t.span('.board-header-btn-divider');
  t.span('.js-board-views-switcher');

  t.div('.board-header-btns.mod-right', function () {
    t.a(
      '.board-header-btn.sub-btn.hide.js-board-header-subscribed',
      { href: '#' },
      function () {
        const watchExperimentVariant = featureFlagClient.getTrackedVariation(
          'teamplates.web.terminology-watch-experiment',
          'not-enrolled',
        );

        const enrolledInWatchExperiment =
          // @ts-expect-error TS(2367): This condition will always return 'false' since th... Remove this comment to see the full error message
          watchExperimentVariant === 'experiment-v1' ||
          // @ts-expect-error TS(2367): This condition will always return 'false' since th... Remove this comment to see the full error message
          watchExperimentVariant === 'experiment-v2';

        // @ts-expect-error TS(2367): This condition will always return 'false' since th... Remove this comment to see the full error message
        if (watchExperimentVariant === 'experiment-v2') {
          t.span(
            '.board-header-btn-icon.board-header-subscribe-icon-container',
          );
        } else {
          t.icon('subscribe', { class: 'board-header-btn-icon' });
        }

        return t.span('.board-header-btn-text', () =>
          enrolledInWatchExperiment ? t.format('follow') : t.format('watch'),
        );
      },
    );

    renderBoardPluginButtons();

    t.span('.board-header-btn-divider');

    t.span(
      '.js-brita-board-filter-btn-container board-header-btn-react-container',
    );

    renderMembersFacepileAndBoardShareButton();

    if (!isEmbeddedInAtlassian) {
      t.span('.board-header-btn-divider');

      t.span('.show-sidebar-button-react-root');
    }
  });
});
